/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cta_ShortInputs */

const en_cta_short = /** @type {(inputs: Cta_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`start`)
};

const ar_cta_short = /** @type {(inputs: Cta_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ`)
};

const bn_cta_short = /** @type {(inputs: Cta_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শুরু করুন`)
};

const de_cta_short = /** @type {(inputs: Cta_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`starten`)
};

const es_cta_short = /** @type {(inputs: Cta_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`empezar`)
};

const fr_cta_short = /** @type {(inputs: Cta_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`commencer`)
};

const pt_cta_short = /** @type {(inputs: Cta_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`começar`)
};

const zh_cta_short = /** @type {(inputs: Cta_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始`)
};

const tr_cta_short = /** @type {(inputs: Cta_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`başla`)
};

const ru_cta_short = /** @type {(inputs: Cta_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`начать`)
};

const pl_cta_short = /** @type {(inputs: Cta_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zacznij`)
};

/**
* | output |
* | --- |
* | "start" |
*
* @param {Cta_ShortInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const cta_short = /** @type {((inputs?: Cta_ShortInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cta_ShortInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_cta_short(inputs)
	if (locale === "bn") return bn_cta_short(inputs)
	if (locale === "de") return de_cta_short(inputs)
	if (locale === "es") return es_cta_short(inputs)
	if (locale === "fr") return fr_cta_short(inputs)
	if (locale === "pt") return pt_cta_short(inputs)
	if (locale === "zh") return zh_cta_short(inputs)
	if (locale === "tr") return tr_cta_short(inputs)
	if (locale === "ru") return ru_cta_short(inputs)
	if (locale === "pl") return pl_cta_short(inputs)
	return en_cta_short(inputs)
});